export const GET_ACTIVE_ORGANIZATIONS_STARTED = 'GET_ACTIVE_ORGANIZATIONS_STARTED'
export const GET_ACTIVE_ORGANIZATIONS_SUCCESS = 'GET_ACTIVE_ORGANIZATIONS_SUCCESS'
export const GET_ACTIVE_ORGANIZATIONS_FAILURE = 'GET_ACTIVE_ORGANIZATIONS_FAILURE'
